import { useMutation } from '@apollo/client';

import { BulkUnassignPurchaseOrder, BulkUnassignPurchaseOrderVariables }
  from '@/graphql/contracts/_generated_/bulkUnassignPurchaseOrder.mutation';
import BulkUnassignPurchaseOrderMutation from '@/graphql/contracts/bulkUnassignPurchaseOrder.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';
import { notificationService } from '@/services/notification/notification.client';
import GetPaginatedFilteredVariableContractLinesQuery from
  '@/graphql/contracts/getPaginatedFilteredVariableContractLines.query.gql';
import { ALL_ITEMS } from '@/config/common.config';
import GetBCContractLinesQuery from '@/graphql/contracts/getPaginatedFilteredBCContractLines.query.gql';

export function useBulkUnassignPurchaseOrder(refreshGrid: boolean, contractId?: UUID, variableSelected?: boolean) {

  const [bulkUnassignPurchaseOrderMutation] =
    useMutation<BulkUnassignPurchaseOrder, BulkUnassignPurchaseOrderVariables>(
      BulkUnassignPurchaseOrderMutation, {
        client: apolloClientContracts,
        awaitRefetchQueries: true,
        ...(refreshGrid ? {
          refetchQueries: [
            {
              query: GetBCContractLinesQuery,
              variables: {
                filter: {
                  contractId: { eq: contractId }
                },
                first: ALL_ITEMS
              }
            },
            ...(variableSelected ? [
              {
                query: GetPaginatedFilteredVariableContractLinesQuery,
                variables: {
                  filter: { headerPrimaryKey: { eq: contractId } },
                  first: ALL_ITEMS,
                }
              }
            ] : [])
          ]
        } : {}),
        onError: (err) => notificationService.open({
          title: 'Error',
          text: err.message,
          type: 'danger'
        })
      }
    );

  const bulkUnassignPurchaseOrder = async (contractLineIds: string[], handleSuccess?: () => void) => {
    bulkUnassignPurchaseOrderMutation({
      variables: {
        contractLineIds: contractLineIds,
      },
      onCompleted: (data) => {
        if (data.bulkUnassignPurchaseOrder && 'errorMessage' in data.bulkUnassignPurchaseOrder
          && data.bulkUnassignPurchaseOrder.errorMessage) {
          notificationService.open({
            title: 'Error',
            text: data.bulkUnassignPurchaseOrder.errorMessage,
            type: 'danger'
          });
          return;
        }
        else {
          if (handleSuccess) {
            handleSuccess();
          }
          notificationService.open({
            title: 'Success',
            text: 'Purchase Order unassigned successfully',
            type: 'success'
          });
        }
      }
    });
  };

  return { bulkUnassignPurchaseOrder };
}
